import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { __param } from 'tslib';
import { MatAutocompleteSelectedEvent, MatOption, MatSelect, MatStepper } from '@angular/material';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-invited-user',
  templateUrl: './invited-user.component.html',
  styleUrls: ['./invited-user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class InvitedUserComponent implements OnInit {
  isLinear = false;
  hide = true;
  hideConformPassword = true;
  invitedUserId: string;
  tenantId: string;
  userRegisterForm: FormGroup;
  userEmailId: string;
  userId: string;
  profileId: string;
  firstName: string;
  lastName: string;
  userName: string;
  nextStepActive: boolean = false;
  isClicked: boolean = false;
  isLinux: boolean = false;
  isWindows: boolean = false;
  isMac: boolean = false;
  downloadApp = false;
  isWebDesktop: any;

  /**
    * Constructor
    *
    * @param {FuseConfigService} _fuseConfigService
    * @param {FormBuilder} _formBuilder
    */

  constructor(
    private _fuseConfigService: FuseConfigService,
    private route: ActivatedRoute,
    public parseService: ParseService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router
  ) {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };
  }

  ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      this.invitedUserId = params.id;
      this.downloadApp = params.downloadApp;
    });
    this.userRegisterForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirm_password: ['', [Validators.required, Validators.minLength(8)]]
    })
    this.GetInvitedUser();
  }

  async GetInvitedUser() {
    let queryInstance = this.parseService.instance.Object.extend('InvitedUser');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.invitedUserId);
    let invitedUser = await query.find();
    if (invitedUser[0].get('isCreated') === true) {
      this.router.navigate(['/login']);
      return;
    }
    this.userEmailId = invitedUser[0].get('email');
    this.tenantId = invitedUser[0].get('tenantId');
    this.userName = invitedUser[0].get('username');
    this.userRegisterForm.patchValue({
      userEmail: this.userEmailId
    });

    let queryInstances = this.parseService.instance.Object.extend('_User');
    let querys = new this.parseService.instance.Query(queryInstances);
    querys.equalTo('email', this.userEmailId);
    querys.equalTo('tenantId', this.tenantId);
    let user = await querys.find();
    this.userId = user[0].id;

    let queryInst = this.parseService.instance.Object.extend('Profile');
    let qur = new this.parseService.instance.Query(queryInst);
    qur.equalTo('email', this.userEmailId);
    qur.equalTo('tenantId', this.tenantId);
    let profile = await qur.find();
    this.profileId = profile[0].id;
    this.isWebDesktop = profile[0].get('isWebDesktop');
  }

  async updateProfile() {
    let firstName = this.userRegisterForm.value.firstName;
    let lastName = this.userRegisterForm.value.lastName;
    let userName = firstName.concat("", lastName);

    let queryInstances = this.parseService.instance.Object.extend('Profile');
    let querys = new this.parseService.instance.Query(queryInstances);
    querys.equalTo('objectId', this.profileId);
    let resultPro = await querys.find();
    let profileDetail = resultPro[0];
    profileDetail.set('firstName', firstName);
    profileDetail.set('lastName', lastName);
    profileDetail.set('username', userName);
    profileDetail.set('password', this.userRegisterForm.value.password);
    profileDetail.set('status', 'Active');
    profileDetail.set('isFirstLogin', true);
    profileDetail.save();
    await this.updateUser();
    await this.updateInvitedUser();
  }

  async updateUser() {
    let firstName = this.userRegisterForm.value.firstName;
    let lastName = this.userRegisterForm.value.lastName;
    let userName = firstName.concat("", lastName);

    let queryInstance = this.parseService.instance.Object.extend('_User');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.userId);
    let result = await query.find();
    let userDetail = result[0];
    userDetail.set('firstName', firstName);
    userDetail.set('lastName', lastName);
    userDetail.set('username', userName);
    userDetail.set('password', this.userRegisterForm.value.password);
    userDetail.set('desktopVerified', false);
    await userDetail.save({}, { useMasterKey: true });
  }

  async updateInvitedUser() {
    let firstName = this.userRegisterForm.value.firstName;
    let lastName = this.userRegisterForm.value.lastName;
    let userName = firstName.concat(" ", lastName);
    let queryInstance = this.parseService.instance.Object.extend('InvitedUser');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.invitedUserId);
    let result = await query.find();
    let invitedUser = result[0];
    invitedUser.set('isCreated', true);
    invitedUser.set('status', "OnBoarding");
    invitedUser.set('firstName', firstName);
    invitedUser.set('lastName', lastName);
    invitedUser.set('username', userName);
    invitedUser.save();
    this.toastr.success('Saved Successfully');
    if (this.isWebDesktop === true) {
      this.navigateToLogin();
    }
  }

  async goNext(stepper: MatStepper) {
    if (this.userRegisterForm.invalid && !this.downloadApp) {
      return;
    }
    const password = this.userRegisterForm.value.password;
    const conformPassword = this.userRegisterForm.value.confirm_password;
    if (password != conformPassword) {
      return this.toastr.warning('Password those not matched');
    }
    stepper.next();
    this.nextStepActive = true;
    await this.updateProfile();
    // if (this.isWebDesktop === true) {
    //   this.navigateToLogin();
    // }
  }
  backpage() {
    this.nextStepActive = false;
  }
  navigateToLogin(): void {
    // this.router.navigate(['login']);
    window.location.href = `${environment.baseUrl}/#/try`;
  }
}


